import { render } from "./downloadFilePopup.vue?vue&type=template&id=16a8136d&ts=true"
import script from "./downloadFilePopup.vue?vue&type=script&lang=ts"
export * from "./downloadFilePopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__